module.exports = __webpack_public_path__ + "static/media/race_ethnicity.03285e15.svg";